import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Stepper } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import { getBlogByID } from "./services/blog.services";
import { clearBlogDetails, clearBlogID, setBlogID } from "./blogSlice";
import { ErrorToast } from "../../components/toast/Toasts";
import BlogDetailsForm from "./BlogDetailsForm";
import BlogFAQSection from "./BlogFAQSection";

const CreateBlog: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const routeBlogID = location.state?.BlogID;

  const BlogID = useAppSelector((state) => state.blog.BlogID);
  const loading = useAppSelector((state) => state.blog.loading);
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    if (routeBlogID) {
      dispatch(setBlogID(routeBlogID));
      dispatch(getBlogByID(routeBlogID));
    }
    return () => {
      dispatch(clearBlogDetails());
      dispatch(clearBlogID());
    };
  }, [routeBlogID]);

  const handleStep1Success = (newBlogID: number) => {
    dispatch(setBlogID(newBlogID));
    navigate("/blog/edit", { state: { BlogID: newBlogID }, replace: true });
    setActiveStep(1);
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <div style={{ padding: "0 24px" }}>
        <div style={{ maxWidth: 600, margin: "20px auto 30px auto" }}>
          <Stepper
            value={activeStep}
            onChange={(e) => {
              if (e.value === 1 && !BlogID) {
                ErrorToast("Please save the blog details first.");
                return;
              }
              setActiveStep(e.value);
            }}
            items={[{ label: "Blog Details" }, { label: "Blog FAQs" }]}
          />
        </div>

        {activeStep === 0 && <BlogDetailsForm onSuccess={handleStep1Success} />}
        {activeStep === 1 && <BlogFAQSection onBack={() => setActiveStep(0)} />}
      </div>
    </>
  );
};

export default CreateBlog;
